// extracted by mini-css-extract-plugin
export default {"root":"ModalImageTitle-root","iconContainer":"ModalImageTitle-iconContainer"};